import { DirectiveBinding } from 'vue';
import formatPrice from '@/helpers/format-price';
import { CustomDirective } from '@/types/custom-directive';

/**
 * Formats the html content of the provided element as price.
 */
function format(el: HTMLElement, binding: DirectiveBinding): void {
  if ((!binding.value && binding.value !== 0) || !el) {
    return;
  }

  const priceInput = parseFloat(binding.value);

  el.classList.add('prevent-wrap');
  el.textContent = Number.isNaN(priceInput)
    ? ''
    : formatPrice(parseFloat(binding.value), binding.modifiers.prefixCurrency || false) || '';
}

/**
 * Directive to provide formatted prices.
 *
 * Examples:
 *
 * Default behaviour (without currency):
 * <span v-price="1000"></span> => 10.00
 *
 * Displaying with currency symbol behind:
 * <span v-price.prefixCurrency="1000"></span> => CHF 10.00
 */
export default {
  name: 'price',
  directive: {
    beforeMount: format,
    updated: format,
  },
} satisfies CustomDirective;
